export default {
  discount: '{discount}% introductory price discount',
  total: 'Total',
  payment_total: '<b>${trial_amount}</b> for 7-day trial',
  disclaimer: 'You’ll pay ${trial_amount} today for your 7-day trial, and then {full_price} per {subscription_period} after your trial ends. Manage your subscription via Billing Center or in the Dr. Kegel app.',
  perDate: 'per {subscriptionDate}',
  saved: 'You just saved {discountAmount} ({discount}% off)',
  pay: 'The safer, easier way to pay',
}
